export default __webpack_public_path__ + "static/media/Arup_Red_RGB.aa5ffc32.svg";